import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Carousel as AntdCarousel } from "antd";
import "./style.scss";

const Carousel = forwardRef(
  (
    {
      infinite = false,
      slides = [],
      slidesToShow = 1,
      slidesToScroll = 1,
      renderItem,
      centerMode = false,
      centerPadding = "0px",
      settings: propSettings = {},
      arrows = false,
      responsive = [],
      variableWidth = false,
      className,
      draggable,
      afterChange,
      autoplay,
      autoplaySpeed,
    },
    ref,
  ) => {
    const carouselRef = useRef(null);
    const [current, setCurrent] = useState(0);

    useImperativeHandle(ref, () => ({
      next: () => carouselRef.current?.next(),
      prev: () => carouselRef.current?.prev(),
      currentIndex: current,
    }));

    const handleAfterChange = (index) => {
      setCurrent(index);
      if (afterChange) {
        afterChange(index);
      }
    };

    const settings = {
      dots: false,
      arrows: arrows,
      infinite,
      speed: 800,
      slidesToShow,
      slidesToScroll,
      centerMode,
      centerPadding,
      draggable: draggable,
      afterChange: handleAfterChange,
      responsive,
      variableWidth,
      className,
      autoplaySpeed,
      autoplay,
      ...propSettings,
    };

    return (
      <AntdCarousel ref={carouselRef} {...settings}>
        {slides.map((item, index) => (
          <React.Fragment key={index}>{renderItem(item, index)}</React.Fragment>
        ))}
      </AntdCarousel>
    );
  },
);

export default Carousel;
